import {
  FETCH_MAKE_MODEL_YEAR_REQUEST,
  FETCH_MAKE_MODEL_YEAR_SUCCESS,
  FETCH_MAKE_MODEL_YEAR_FAILURE
} from './MakeModelYearTypes';

const initialState = {
  loading: false,
  mmyData: [],
  error: ''
};  

const makeModelYearReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MAKE_MODEL_YEAR_REQUEST: 
        return {    
            ...state,
            loading: true
        };
    case FETCH_MAKE_MODEL_YEAR_SUCCESS:
        return {
            ...state,
            loading: false,
            mmyData: action.payload
        };
    case FETCH_MAKE_MODEL_YEAR_FAILURE:
        return {
            ...state,
            loading: false,
            mmyData: [],
            error: action.payload
        };
    default:
        return state;
  }
};

export default makeModelYearReducer;